// src/components/Popups/generateChecklistReport.js
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import logo from '../../../img/logo rio verde pdf.png'; // Caminho atualizado para o logo

// Função para desenhar um cabeçalho de seção estilizado
const drawSectionHeader = (doc, text, y) => {
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(34, 139, 34); // Verde

    doc.setDrawColor(34, 139, 34);
    doc.setLineWidth(0.5);
    doc.line(14, y - 4, 30, y - 4);

    doc.text(text.toUpperCase(), 14, y);
};

const generateChecklistReport = (vehicle, checklist) => {
    // --- LÓGICA ATUALIZADA ---
    // Pega o nome do usuário logado diretamente do localStorage
    const currentUser = localStorage.getItem('username') || 'N/A';
    // --- FIM DA LÓGICA ATUALIZADA ---

    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;

    let currentY = 15;

    // -- Cores e Fontes --
    const themeColor = [34, 139, 34];
    const lightGrayBg = [248, 249, 250];
    const darkGrayText = [50, 50, 50];

    // -- CABEÇALHO --
    doc.addImage(logo, 'PNG', 14, currentY - 5, 40, 15);
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...darkGrayText);
    doc.text('CHECKLIST DE MANUTENÇÃO', pageWidth - 14, currentY + 5, { align: 'right' });

    currentY += 25;

    // -- BLOCO DE INFORMAÇÕES DO VEÍCULO --
    doc.setFontSize(22);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...darkGrayText);
    doc.text(`${vehicle.marca || ''} ${vehicle.modelo || ''}`, 14, currentY);

    doc.setDrawColor(...themeColor);
    doc.setLineWidth(0.5);
    doc.line(14, currentY + 3, pageWidth - 14, currentY + 3);
    
    currentY += 10;

    // -- BLOCO DE INFORMAÇÕES DO CHECKLIST --
    drawSectionHeader(doc, 'Detalhes do Checklist', currentY);
    currentY += 10;

    doc.setFillColor(...lightGrayBg);
    doc.roundedRect(14, currentY - 5, pageWidth - 28, 20, 3, 3, 'F');

    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...darkGrayText);
    doc.text('Título:', 20, currentY + 3);
    doc.text('Data de Emissão:', 20, currentY + 10);

    doc.setFont('helvetica', 'normal');
    doc.text(checklist.titulo || 'Sem Título', 45, currentY + 3);
    doc.text(new Date().toLocaleDateString('pt-BR'), 55, currentY + 10);

    currentY += 25;

    // -- TABELA DE ITENS (CHECKLIST) --
    drawSectionHeader(doc, 'Itens a Verificar', currentY);
    currentY += 5;

    const tableBody = (checklist.itens || []).map(item => ['', item.descricao, '']);

    doc.autoTable({
        startY: currentY,
        head: [['', 'Item do Checklist', 'Observações']],
        body: tableBody,
        theme: 'striped',
        headStyles: { 
            fillColor: darkGrayText, 
            textColor: [255, 255, 255], 
            fontStyle: 'bold', 
            fontSize: 10,
            halign: 'center'
        },
        columnStyles: { 
            0: { cellWidth: 15, halign: 'center' },
            1: { cellWidth: 'auto' },
            2: { cellWidth: 60 }
        },
        didDrawCell: (data) => {
            if (data.section === 'body' && data.column.index === 0) {
                const checkboxSize = 4;
                const cell = data.cell;
                const x = cell.x + (cell.width / 2) - (checkboxSize / 2);
                const y = cell.y + (cell.height / 2) - (checkboxSize / 2);

                doc.setDrawColor(150, 150, 150);
                doc.setLineWidth(0.3);
                doc.rect(x, y, checkboxSize, checkboxSize, 'D');
            }
        },
        styles: {
            valign: 'middle',
            fontSize: 10
        }
    });

    currentY = doc.lastAutoTable.finalY;

    // -- ASSINATURAS --
    currentY += 15;
    drawSectionHeader(doc, 'Assinaturas', currentY);

    const signatureBoxWidth = (pageWidth - 28 - 10) / 2;
    const signatureBoxY = currentY + 5;
    const signatureBoxHeight = 30;

    doc.setDrawColor(200, 200, 200);
    doc.setLineWidth(0.3);

    doc.roundedRect(14, signatureBoxY, signatureBoxWidth, signatureBoxHeight, 2, 2, 'D');
    doc.setTextColor(100);
    doc.setFontSize(8);
    doc.text('Responsável pela Manutenção', 18, signatureBoxY + 5);

    doc.roundedRect(14 + signatureBoxWidth + 10, signatureBoxY, signatureBoxWidth, signatureBoxHeight, 2, 2, 'D');
    doc.text('Operador do Veículo', 18 + signatureBoxWidth + 10, signatureBoxY + 5);

    // -- RODAPÉ --
    doc.setFillColor(...lightGrayBg);
    doc.rect(0, pageHeight - 15, pageWidth, 15, 'F');
    doc.setFontSize(8);
    doc.setTextColor(150);
    const footerText = `Gerado por: ${currentUser} | Sistema de Frota | ${new Date().toLocaleString('pt-BR')}`;
    doc.text(footerText, pageWidth / 2, pageHeight - 8, { align: 'center' });
    
    // MODIFICAÇÃO: Ajusta o nome do arquivo se a placa não existir
    const fileName = `checklist_${vehicle.placa || 'veiculo'}.pdf`;
    doc.save(fileName);
};

export default generateChecklistReport;